import { createServerFn } from "@tanstack/react-start";
import { fetchXrpEtfTracker } from "./etf.server";
import { fetchOnrampQuotes } from "./onramp-quotes.server";

export const getXrpEtfTracker = createServerFn({ method: "GET" }).handler(async () =>
  fetchXrpEtfTracker(),
);

export const getOnrampQuotes = createServerFn({ method: "GET" })
  .inputValidator((data: { usdAmount: number }) => ({
    usdAmount: Math.max(1, Math.min(50_000, Number(data?.usdAmount) || 250)),
  }))
  .handler(async ({ data }) => fetchOnrampQuotes(data.usdAmount));

export const getOfframpQuotes = createServerFn({ method: "GET" })
  .inputValidator((data: { xrpAmount: number }) => ({
    xrpAmount: Math.max(1, Math.min(1_000_000, Number(data?.xrpAmount) || 500)),
  }))
  .handler(async ({ data }) =>
    (await import("./onramp-quotes.server")).fetchOfframpQuotes(data.xrpAmount),
  );
